import { render } from "./StoreTab.vue?vue&type=template&id=206612c2"
import script from "./StoreTab.vue?vue&type=script&lang=js"
export * from "./StoreTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__